export default function ({ item }) {
  return <p className="ellipsis">{item.user.email}</p>;
}
